import { render } from "./LinkCgModal.vue?vue&type=template&id=51c0df26&scoped=true"
import script from "./LinkCgModal.vue?vue&type=script&lang=js"
export * from "./LinkCgModal.vue?vue&type=script&lang=js"

import "./LinkCgModal.vue?vue&type=style&index=0&id=51c0df26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c0df26"]])

export default __exports__